export default function dateMessage( dateReceived, group = false ) {

  const date = new Date( dateReceived + ( group ? "T00:00:00" : "" ));
  const now = new Date();
    
  // Ajustar para o mesmo horário para comparar apenas as datas
  const startOfToday = new Date( now.getFullYear(), now.getMonth(), now.getDate() );
  const startOfDate = new Date( date.getFullYear(), date.getMonth(), date.getDate() );

  const diffTime = Math.abs( startOfToday - startOfDate );
  const diffDays = Math.ceil( diffTime / ( 1000 * 60 * 60 * 24 ));
    
  let response;

  if ( diffDays === 0 ) {
    // Hoje, se não for um group de message retorna a hora da mensagem
    if ( group ) {
      response = "Hoje";
    } else {
      const hours = date.getHours();
      const minutes = date.getMinutes();
      const formattedHours = String(hours).padStart(2, "0");
      const formattedMinutes = String(minutes).padStart(2, "0");
      response = `${ formattedHours }:${ formattedMinutes }`;
    }
  } else if ( diffDays === 1 ) {
    // Ontem
    response = "Ontem";
  } else if ( diffDays > 1 && diffDays <= 7 ) {
    // Últimos sete dias: mostrar o nome do dia da semana
    const weekDays = [ "Domingo", "Segunda-Feira", "Terça-Feira", "Quarta-Feira", "Quinta-Feira", "Sexta-Feira", "Sábado" ];
    response = weekDays[ date.getDay() ];
  } else {
    // Mais de sete dias: formato "dd/mm/aaaa"
    const day = String( date.getDate() ).padStart( 2, "0" );
    const month = String( date.getMonth() + 1 ).padStart( 2, "0" );
    const year = date.getFullYear();
    response = `${ day }/${ month }/${ year }`;
  }
  return response;
}